import React from 'react';
import { Box } from '@chakra-ui/react';
import { Trans } from 'react-i18next';
import moment from 'moment';
import PropTypes from 'prop-types';

const NotFound = () => {
  return (
    <Box>
      <Trans i18nKey="common.dateNotFound" />
    </Box>
  );
};

const ChablaDateAndTime = (props) => {
  const { startTime, duration } = props;

  if (!startTime) {
    return NotFound();
  }

  const d = moment(startTime);

  if (!d.isValid()) {
    return NotFound();
  }

  if (!duration || !Number.isInteger(Number(duration))) {
    return NotFound();
  }

  // simple localization - presumably we don't need to support year/mm/dd format but to use finnish format for all languages
  const dateVal = d.format('DD.MM.YYYY');
  const timeVal = d.format('HH:mm');
  const timeEndVal = d.add(duration, 'seconds').format('HH:mm');

  return (
    <Box>
      <Trans
        i18nKey="common.dateAndTime"
        values={{ date: dateVal, timeStart: timeVal, timeEnd: timeEndVal }}
      />
    </Box>
  );
};

ChablaDateAndTime.propTypes = {
  startTime: PropTypes.any,
  duration: PropTypes.number,
};

export default ChablaDateAndTime;
